<script>
import moment from "moment";

export default {
  name: "RoomLock",
  data() {
    return {};
  },
  emits: ["assing-lock", "redirect-to-keylog"],
  props: {
    lock: Object,
    fIndex: String,
  },
  methods: {
    // Method is used to check lock online or offline
    checkLockStatus(date, room_number) {
      // console.log(
      //   moment(date).format("YYYY-MM-DD"),
      //   moment().tz(this.hotel.timezone).diff(date, "minutes"),
      //   room_number
      // );
      return moment().format("YYYY-MM-DD") == moment(date).format("YYYY-MM-DD")
        ? moment().diff(date, "minutes") > 30
          ? false
          : true
        : false;
    },
  },
};
</script>
<template>
  <div
    class="card lock-box"
    :class="lock.lock_iot_device == null ? 'bg-secondary bg-soft' : ''"
  >
    <div
      class="d-flex align-items-center justify-content-between"
      @click="$emit('assing-lock', (lock, fIndex))"
    >
      <div
        class="d-flex align-items-center"
        v-if="lock.lock_iot_device !== null"
      >
        <div
          class="battery success"
          v-if="lock.lock_iot_device.last_status.battery > 70"
        >
          <div
            class="battery-level"
            :style="`width: ${lock.lock_iot_device.last_status.battery}%`"
          ></div>
        </div>
        <div
          class="battery warn"
          v-else-if="
            lock.lock_iot_device.last_status.battery < 70 &&
            lock.lock_iot_device.last_status.battery > 30
          "
        >
          <div
            class="battery-level"
            :style="`width: ${lock.lock_iot_device.last_status.battery}%`"
          ></div>
        </div>
        <div class="battery alert mb-0" v-else>
          <div
            class="battery-level"
            :style="`width: ${lock.lock_iot_device.last_status.battery}%`"
          ></div>
          <i class="mdi mdi-lightning-bolt alert-leval"></i>
        </div>
        <span class="text-secondary ms-1"
          >{{
            lock.lock_iot_device
              ? lock.lock_iot_device.last_status.battery
                ? lock.lock_iot_device.last_status.battery > 100
                  ? 100
                  : lock.lock_iot_device.last_status.battery
                : "100"
              : "100"
          }}%</span
        >
      </div>
      <i
        v-if="lock.lock_iot_device !== null"
        class="fs-4 d-block ms-auto"
        :class="[
          !lock.lock_iot_device.last_status.deadbolt
            ? 'mdi mdi-lock-open-variant-outline text-success'
            : 'mdi mdi-lock-outline text-danger',
        ]"
      >
      </i>
      <i v-else class="mdi mdi-lock-plus-outline fs-4 d-block ms-auto"></i>
    </div>
    <div
      class="lock-box-text d-flex align-items-center justify-content-center cursor"
      @click="$emit('redirect-to-keylog', (lock, 'door_log'))"
    >
      <h2
        class="mb-0"
        :class="lock.lock_iot_device != null ? 'text-secondary' : ''"
      >
        <span
          :class="
            lock.lock_iot_device !== null
              ? checkLockStatus(
                  lock.lock_iot_device.updated_at,
                  lock.room_number
                )
                ? 'text-success'
                : 'text-danger'
              : 'text-secondary'
          "
        >
          {{ lock.room_number }}
        </span>
      </h2>
    </div>
    <i
      class="fas fa-bed d-block text-center fs-3"
      :class="
        lock.lock_iot_device !== null
          ? lock.booking == null
            ? 'text-secondary opacity-25'
            : 'text-success'
          : 'text-secondary opacity-25'
      "
    ></i>
  </div>
</template>
<style scoped>
.lock-box {
  width: 200px;
  min-height: 172px;
  padding: 14px;
  border-radius: 6px;
  margin: 10px;
}
.lock-box-text {
  min-height: 100px;
}
.lock-box-text h2 {
  font-size: 30px;
}
</style>
